module.exports = __webpack_public_path__ + "static/logo-39ea849ba7ab735b561fee3f668047ef.png";